var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramAccessibility64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./UpdatesAccessibility64*-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Accessibility",
    transform: "translate(8.000000, 8.000000)",
    fillRule: "nonzero",
    stroke: "#4F4D4C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFCC00",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(10.147575, 5.327916)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0235304,22.6720844 L13.7692293,22.6720844 L10.2623874,34.1424473 C9.93944257,35.1987524 8.82133958,35.7932583 7.76503452,35.4703134 C6.70872945,35.1473685 6.11422355,34.0292655 6.43716841,32.9729605 L9.852425,21.8021595 L9.852425,13.6720844 L8.977425,13.6720844 L3.00173048,13.0362147 C1.77958889,12.9061675 0.852425005,11.8751104 0.852425005,10.6460691 C0.852425005,9.56224313 1.73103959,8.68362854 2.81486561,8.68362854 C2.87796093,8.68362854 2.94101955,8.68667145 3.00382172,8.69274667 L9.789925,9.34920547 L17.914925,9.34920547 L24.7010283,8.69274667 C25.7798185,8.58838909 26.7389493,9.37832281 26.8433069,10.457113 C26.8493821,10.5199152 26.852425,10.5829738 26.852425,10.6460691 C26.852425,11.8751104 25.9252611,12.9061675 24.7031195,13.0362147 L18.727425,13.6720844 L17.852425,13.6720844 L17.852425,21.5146198 L21.3555913,32.9729605 C21.6785362,34.0292655 21.0840303,35.1473685 20.0277252,35.4703134 C18.9714201,35.7932583 17.8533171,35.1987524 17.5303723,34.1424473 L14.0235304,22.6720844 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 13.852425,
    cy: 3.67208438,
    r: 3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramAccessibility64);
export default __webpack_public_path__ + "static/media/pictogramAccessibility64.ff27e6d15ec79375af7bcdc7a7e290f2.svg";
export { ForwardRef as ReactComponent };